import React from "react";
//#region types
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Grid } from "@mui/material";
import Logo from "images/logo-large.png";
import cssExports from "theme/styles/main.module.scss";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const EULAHeader: React.FC = (props) => {
  return (
    <Grid container className={cssExports.eulaHeaderContainer} direction="row" wrap="nowrap">
      <Grid item>
        <img src={Logo} className={cssExports.headerLogoImg} />
      </Grid>
      <Grid item xs>
        <Grid item className={cssExports.title}>
          <span>{LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Eula.TermsAndConditions)}</span>
        </Grid>
        <Grid item className={cssExports.subTitle}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Eula.HeaderText)}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default EULAHeader;
